import dataService from 'services/dataService';
import { showResult } from 'infrastructure/hooks/utils';

interface DataProps {
  url: string;
}

export interface IKeyNoteHistory {
  updatedBy?: string;
  createdBy: string;
  note: string;
  createdAt: string;
  expiresAt: string | null;
}

export const getKeyNotesHistory = async ({ url }: DataProps) => {
  const { error, data } = await dataService.getList<IKeyNoteHistory>(url);

  if (error) {
    showResult(error);
  }

  return data;
};
